import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export const templateTypes = {
    PDF_TICKET: 11,
    PDF_BADGE: 12
};

export default class DesignTemplateModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][TemplateDesign] organizationId is mandatory`);
        }
        if (eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/templates`;
        }
        return `/ticket/organizations/${organizationId}/templates`;
    }

    static perform_validate(object, { organization }) {
        const data = { data: object };
        return fetcher.post(`/ticket/organizations/${organization.id}/templates/validate_syntax_twig`, data);
    }

    static perform_delete(objects, { organization }) {
        const data = { data: objects.map(({ pk }) => pk) };
        return fetcher.delete(`/ticket/organizations/${organization.id}/templates`, data);
    }
}
